
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_(c(rd(Credits_Module_crdCredits|Dashboard_Module_crdDashboard|Details_Module_crdDetails)_Module|(heckbookEvents_Module_checkbookEven|ontracts_Module_contrac)ts_Module)|((eventsApprovals_Module_eventsApproval|paymentOperations_Module_paymentOperation|reports_Module_report)s|home_Module_home)_Module)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
